module.exports = __webpack_public_path__ + "img/msg_notice.15f9dda1.svg";